declare const I18n;

import React, { useState, useEffect } from "react";
import Header from "@/components/Header";
import LearnersTabs from "../components/LearnersTab";
import LearnersOverview from "../components/LearnersOverview";
import LearnersProgress from "../components/LearnersProgress";

type LearnersIndexProps = {
  learners: any[];
  metadata: any;
  digital_interests: any[];
  experience_levels: any[];
  recommended_courses: any[];
  isFacilitator: boolean;
};

const LearnersIndex: React.FC<LearnersIndexProps> = ({
  digital_interests,
  experience_levels,
  recommended_courses,
  isFacilitator
}) => {
  const params = new URLSearchParams(window.location.search);
  const initialTab = "overview";

  const [currentTab, setCurrentTab] = useState(initialTab);

  useEffect(() => {
    if (params.has("tab")) {
      const url = new URL(window.location.href);
      url.searchParams.delete("tab");
      window.history.replaceState({}, "", url.toString());
    }
  }, []);

  return (
    <div>
      <Header title={I18n.t("views.nav.learners")} showIcon={false} />

      <LearnersTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />

      {currentTab === "overview" && (
        <LearnersOverview digitalInterests={digital_interests} experienceLevels={experience_levels} recommendedCourses={recommended_courses} isFacilitator={isFacilitator}/>
      )}

      {currentTab === "progress" && (
        <LearnersProgress isFacilitator={isFacilitator}/>
      )}
    </div>
  );
};

export default LearnersIndex;
